/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import {
  Checkbox,
  FormControlLabel,
  TextField,
  RadioGroup,
} from '@material-ui/core';
import { Button, Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useHistory } from 'react-router-dom';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { CMSUnitInformation, AdjustedClaimsData } from './tableHead';
import {
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import PaginationBox from './PaginationBox';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  viewPortHeight_200,
  viewPortHeight_355,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import {
  dispatchUnitChangedType,
  dispatchDisputeResolution,
  dispatchInvoiceStatus,
  getUnitList,
  getDrugNameList,
  setPaginationIndex,
  dispatchAdjustedClaim,
  setDrugSeqNumber,
  setLoadedClaimLoad,
} from '../Store/action';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import {
  callSearchClaimAPI,
  getClaimTableInfo,
  setSelectedClaim,
  setSelectedClaimMode,
} from '../../../Display/Claim/store/action';
import { naviagteToNDCDetailsPageAction } from '../../../Display/NDC/store/action';
import {
  getNdcGrid,
  getUnitConversionDetail,
} from '../../../Maintain/unitConversion/store/actions';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import exportAdjustedClaimsPDF from './exportAdjustedClaimsPDF';
import buildAdjustedClaimsDocDefinition from './AdjustedClaimsDocDefinition';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { dispatchTableLoader } from '../../../../SharedModules/Table/store/Actions';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const DisplayAdjustedClaims = (props) => {
  const {
    displayObj: {
      rebateProgramName: getRebateProgramName,
      claimcategorySelectedValue: getClaimCategoryName,
      billed,
      notBilled,
      yes,
      no,
      invoice,
      nonInvoiced,
      startQtr: startQtrValue,
      endQtr: endQtrValue,
      countValue,
      drugData: drugDataList,
      selectBy: getSelectByList,
    },

    drugSeqData: drugNameList,
  } = useSelector((state) => state?.sharedState?.AdjustedClaimReducer);
  const adjustedGridReduxList = useSelector(
    (state) => state?.sharedState?.AdjustedClaimReducer?.adjustedGrid
  );
  const getUnitGridList = useSelector(
    (state) =>
      state?.sharedState?.AdjustedClaimReducer?.unitGrid
        ?.adjustedClaimsUnitGridVO
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const providerTypeList = useSelector((state) => {
    return state?.sharedState.AdjustedClaimReducer?.providerCd;
  });
  const fetchDrugSeqNumber = useSelector((state) => {
    return state?.sharedState.AdjustedClaimReducer?.drugSeqNumber;
  });
  const paginatelist = useSelector((state) => {
    return state?.sharedState.AdjustedClaimReducer?.paginatelist;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer?.CommentListData;
  });
  const logInUser = useSelector((state) => {
    return state?.sharedState?.SharedReducer?.logInUser;
  });
  const dispatch = useDispatch();
  const history = useHistory();
  const [showComments, setShowComments] = React.useState(false);
  const [corrLinkId, setCorrLinkId] = React.useState(null);
  const [fullScreenView1, setFullScreenView1] = useState(false);
  const [fullScreenView2, setFullScreenView2] = useState(false);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [drugNameData, setDrugNameData] = useState([]);
  const [checkboxValuesUnit, setCheckboxValuesUnit] = useState({
    billed: billed,
    notBilled: notBilled,
  });
  const [checkboxValuesDispute, setCheckboxValuesDispute] = useState({
    yes: yes,
    no: no,
  });
  const [checkboxValuesInvoice, setCheckboxValuesInvoice] = useState({
    invoice: invoice,
    nonInvoiced: nonInvoiced,
  });
  // pagination
  const paginationLength = paginatelist?.length || 0; // forPagination[getSelectByList]?.length;
  const [count, setCount] = useState(countValue);
  const [errorMessages, setErrorMessages] = useState([]);
  const [callAPI, setCallAPI] = useState(false);
  const [paginationArray, setPaginationArray] = useState([
    ...Array(paginationLength).keys(),
  ]);

  const unitGridApiRef = useRef(null);
  const adjGridApiRef = useRef(null);

  useEffect(() => {
    setCount(countValue || 1);
  }, [countValue]);

  // To handle next and previous button of pagination
  const handleClick = (type, value) => {
    if (type === 'next') {
      dispatch(setPaginationIndex(count + 1));
      dispatch(setLoadedClaimLoad(false));
    }

    if (type === 'previous') {
      dispatch(setPaginationIndex(count - 1));
      dispatch(setLoadedClaimLoad(false));
    }

    if (type === 'change') {
      // if (value < 1 || value > paginationArray.length) {
      //   dispatch(setPaginationIndex(paginationArray.length));
      // } else {
      if (!value) setErrorMessages([constantMessageData.PAGINATION_EMPTY_ERR]);
      else if (value < 1)
        setErrorMessages([constantMessageData.PAGINATION_NEGATIVE_ERR]);
      else if (value > paginationArray.length)
        setErrorMessages([constantMessageData.PAGINATION_OVER_TOTAL_ERR]);
      else {
        setErrorMessages([]);
        dispatch(setPaginationIndex(value));
      }
    }
  };

  // TO handle any changes in the pagination text field
  const handleBlur = (value) => {
    // if (
    //   value < 1 ||
    //   parseInt(value) > paginationArray.length ||
    //   value === '' ||
    //   isNaN(value)
    // ) {
    //   dispatch(setPaginationIndex(0));

    //   setTimeout(() => {
    //     value < 1
    //       ? dispatch(setPaginationIndex(1))
    //       : dispatch(setPaginationIndex(paginationArray.length));
    //   }, 20);
    // } else {
    if (!value) setErrorMessages([constantMessageData.PAGINATION_EMPTY_ERR]);
    else if (value < 1)
      setErrorMessages([constantMessageData.PAGINATION_NEGATIVE_ERR]);
    else if (value > paginationArray?.length)
      setErrorMessages([constantMessageData.PAGINATION_OVER_TOTAL_ERR]);
    else {
      setErrorMessages([]);
      dispatch(setLoadedClaimLoad(false));
      dispatch(setPaginationIndex(parseInt(value)));
    }
  };

  // selection basis-select by
  const selectByBasis = {
    Labeler: {
      drugSeqNumber: paginatelist
        ? paginatelist[count - 1]?.drugSeqNum
        : fetchDrugSeqNumber,
      NDC: paginatelist ? paginatelist[count - 1]?.ndc : '',
      drugName: paginatelist ? paginatelist[count - 1]?.drugName : '',
    },
    NDC: {
      drugSeqNumber: paginatelist
        ? paginatelist[count - 1]?.drugSeqNum
        : fetchDrugSeqNumber,
      NDC: paginatelist ? paginatelist[count - 1]?.ndc : '',
      drugName: paginatelist ? paginatelist[count - 1]?.drugName : '',
    },
    All: {
      drugSeqNumber: paginatelist
        ? paginatelist[count - 1]?.drugSeqNum
        : fetchDrugSeqNumber,
      NDC: paginatelist ? paginatelist[count - 1]?.ndc : '',
      // drugName: drugNameData?.map((item) => Object.values(item)[0].drugName),
    },
  };
  // claim category
  const stringParts = getClaimCategoryName?.split(' | ');
  const claimShort = stringParts[0]?.trim();
  const claimLong = stringParts[1]?.trim();

  // current quarter
  const today = new Date();
  const quarter = Math.floor(today.getMonth() / 3) + 1;
  const year = today.getFullYear();
  const quarterString = quarter.toString();
  const yearString = year.toString();
  const formattedQuarter = quarterString.padStart(2);
  const currentQuarterWithYear = `${formattedQuarter}Q${yearString}`;

  // handling full screen view
  const handleFullScreenView1 = () => {
    setFullScreenView1(!fullScreenView1);
  };
  const handleFullScreenView2 = () => {
    setFullScreenView2(!fullScreenView2);
  };

  // unit grid api
  useEffect(() => {
    if (selectByBasis[getSelectByList]?.drugSeqNumber) {
      dispatch(
        getUnitList({
          drugSeqNumber: selectByBasis[getSelectByList].drugSeqNumber,
        })
      );
      dispatch(
        getDrugNameList({
          drugSeqNumber: selectByBasis[getSelectByList].drugSeqNumber,
        })
      );
    }
  }, [count]);

  const detail_loaded = useSelector((state) => {
    return state?.sharedState.AdjustedClaimReducer?.detail_loaded;
  });
  // adjusted grid api
  useEffect(() => {
    if (!detail_loaded) {
      setCallAPI(true);
      dispatch(setLoadedClaimLoad(true));
      if (selectByBasis[getSelectByList]?.drugSeqNumber) {
        dispatch(
          setDrugSeqNumber(selectByBasis[getSelectByList].drugSeqNumber)
        );
      }
      // dispatch(
      //   getAdjustedClaimList({
      //     drugSeqNumber:
      //       getSelectByList === 'NDC'
      //         ? drugDataList?.map((o) => o.drugSeqNum)
      //         : [selectByBasis?.[getSelectByList]?.drugSeqNumber],
      //     startQuarter: startQtrValue,
      //     endQuarter: endQtrValue || currentQuarterWithYear,
      //     rebateProgram: getRebateProgramName?.rebateProgramCd,
      //     invoiceInd: checkboxValuesInvoice.invoice ? 1 : 0,
      //     nonInvoiceInd: checkboxValuesInvoice.nonInvoiced ? 1 : 0,
      //     disputeCheck: checkboxValuesDispute.yes ? 1 : 0,
      //     disputeuncheck: checkboxValuesDispute.no ? 1 : 0,
      //     billedUnits: checkboxValuesUnit.billed ? 1 : 0,
      //     notBilledUnits: checkboxValuesUnit.notBilled ? 1 : 0,
      //     claimCategory: claimShort,
      //     useType:
      //       getSelectByList === 'All'
      //         ? 'A'
      //         : getSelectByList === 'NDC'
      //         ? 'N'
      //         : 'M',
      //     mfgId:
      //       getSelectByList === 'Labler'
      //         ? selectedlabelerm?.[0].labelerCode
      //         : '',
      //   })
      // );
    }
  }, [count, checkboxValuesInvoice, checkboxValuesDispute, checkboxValuesUnit]);
  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (showComments) {
      const tempObj =
        adjustedGridReduxList &&
        adjustedGridReduxList?.map((item) => {
          if (
            item.corrLinkId === corrLinkId &&
            commentsList &&
            commentsList.length > 0
          ) {
            item.ccCommentsExist = 1;
          } else if (item.corrLinkId === corrLinkId) {
            item.ccCommentsExist = 0;
          }
          return item;
        });
      dispatch(dispatchAdjustedClaim(tempObj));
    }
  }, [commentsList]);
  // adjusted grid drug name if all is selected
  useEffect(() => {
    setDrugNameData(drugNameList?.adjustedClaimsHeaderGridVO);
  }, [drugNameList]);
  // useEffect(() => {
  //   if (
  //     getSelectByList === 'All' &&
  //     selectByBasis[getSelectByList]?.drugSeqNumber
  //   ) {
  //     dispatch(
  //       getDrugNameList({
  //         drugSeqNumber: selectByBasis[getSelectByList].drugSeqNumber,
  //       })
  //     );
  //   }
  // }, [count]);
  // pinned row

  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const sum = (property) => {
    const displayedRows = filterApply
      ? filteredRows
      : adjustedGridReduxList?.filter(
          (o) => o.drugSeqNum === selectByBasis[getSelectByList].drugSeqNumber
        );

    const data = displayedRows?.reduce((accumulator, object) => {
      return (
        accumulator + (object[property] ? parseFloat(object[property]) : null)
      );
    }, 0);
    return data ? parseFloat(data) : 0;
  };
  const createData = (count) => {
    const result = [];
    for (let i = 0; i < count; i += 1) {
      result.push({
        isBottomRow: true,
        claimId: '',
        claimLineNum: '',
        providerId: '',
        providerIdTypeCd: '',
        prescriptionNum: '',
        origNumOfUnits: sum('origNumOfUnits').toFixed(4),
        numOfUnits: sum('numOfUnits').toFixed(4),
        billedUnits: sum('billedUnits').toFixed(4),
        submittedAmt: sum('submittedAmt'),
        allowedAmt: sum('allowedAmt'),
        reimbursementAmt: sum('reimbursementAmt'),
      });
    }
    return result;
  };
  const pinnedBottomRowData = useMemo(() => {
    return createData(1, 'Bottom');
  }, [adjustedGridReduxList, filteredRows, filterApply]);
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  // pdf header
  let firstInfo = '';
  let secondInfo = '';
  let thirdInfo = '';
  let fourthInfo = '';
  let fifthInfo = '';
  firstInfo = `NDC : ${selectByBasis[getSelectByList].NDC}`;
  fourthInfo = `Drug Name: ${
    selectByBasis[getSelectByList]?.drugName ||
    (drugNameData && drugNameData[0]?.drugName)
  }`;
  thirdInfo = `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`;
  secondInfo = `Quarter : ${startQtrValue}`;
  fifthInfo = `Claim Category Cd: ${claimLong}`;
  // navigation

  // handing Claims page redirect
  const handleViewDetailsForClaims = async () => {
    const resultData = await callSearchClaimAPI({
      rebateProgramCd: getRebateProgramName?.rebateProgramCd,
      paidQtr: startQtrValue,
      searchByNdc: true,
      drugSqnNum: [selectByBasis[getSelectByList].drugSeqNumber],
    });
    if (resultData && resultData?.length > 0) {
      dispatch(setSelectedClaimMode('display'));
      dispatch(getClaimTableInfo(true));
      dispatch(setSelectedClaim(resultData));
      redirectURLLink('/selected-claim', 'Selected Claim', history, dispatch);
    } else {
      handleScrollToEvent();
      setErrorMessages([constantMessageData.MNFC_NDC_ERROR_MSG]);
      await Promise.resolve().then(()=> {
        setErrorMessages([])
      });
      // setTimeout(() => setErrorMessages([]), 5000);
    }
  };
  const goToNdcPage = () => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === '/ndc-details') === -1) {
      updateTabs.push({
        navTo: '/ndc-details',
        value: 'NDC Details',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: '/ndc-details',
    });
  };
  // handing Unit conversion page redirect
  const handleViewDetailsForUnitConversion = async () => {
    dispatch(
      getUnitConversionDetail({
        drugSeqNum: [selectByBasis[getSelectByList].drugSeqNumber],
      })
    );
    const result = await dispatch(
      getNdcGrid({
        drugSeqNum: selectByBasis[getSelectByList].drugSeqNumber,
      })
    );
    if (result.payLoad && result.payLoad?.length > 0) {
      redirectURLLink(
        '/unitConversion-detail',
        'Display Unit Conversion for NDC',
        history,
        dispatch
      );
    } else {
      handleScrollToEvent();
      setErrorMessages([constantMessageData.MNFC_NDC_ERROR_MSG]);
      await Promise.resolve().then(()=> {
        setErrorMessages([])
      });
      // setTimeout(() => setErrorMessages([]), 5000);
    }
  };
  const navigateHandler = (value) => {
    if (value === 'claims') {
      handleViewDetailsForClaims();
    }

    if (value === 'NDC') {
      dispatch(
        naviagteToNDCDetailsPageAction({
          succesFunc: () => {
            goToNdcPage();
          },
          ndcDetailsTableData: [
            {
              ndc: selectByBasis[getSelectByList].NDC,
              drugName:
                selectByBasis[getSelectByList]?.drugName ||
                (drugNameData && drugNameData[0]?.drugName),
            },
          ],
        })
      );
    }
    if (value === 'Unit conversion') {
      handleViewDetailsForUnitConversion();
    }
  };
const getShortDescriptionByCode = (codeValue, array)=>{

const match = array.find(item => item.codeValue === codeValue);
  return match ? match.codeValue+'-'+match.shortDescription : '';

}

  const exportAllToPDF = async (fName) => {
    const fileName = fName || 'AdjustedClaims';

    try {
      dispatch(dispatchTableLoader(true));

      const drugSeqListForExport = paginatelist?.map((item) => item.drugSeqNum) || [];

      if (drugSeqListForExport.length === 0) {
        setErrorMessages([constantMessageData.STATUS_MSG]);
        dispatch(dispatchTableLoader(false));
        return;
      }

      const apiPayload = {
        drugSequenceList: drugSeqListForExport,
      };

      const response = await axios.post(
        serviceEndPoint.GET_ADJUSTED_ALL_CLAIMS_DATA,
        apiPayload
      );

      if (
        response?.data?.adjustedClaimsUnitsHeaderResponseVO?.adjustedClaimsUnitGridVO &&
        response?.data?.adjustedClaimsUnitsHeaderResponseVO?.adjustedClaimsHeaderGridVO
      ) {
        const unitGridDataAll = response.data.adjustedClaimsUnitsHeaderResponseVO.adjustedClaimsUnitGridVO;
        const headerGridDataAll = response.data.adjustedClaimsUnitsHeaderResponseVO.adjustedClaimsHeaderGridVO;

        const allAdjustedClaimsData = adjustedGridReduxList || [];

        const groupedByDrugSeq = {};
        
        const headerDataMap = {};
        headerGridDataAll.forEach((header) => {
          headerDataMap[header.drugSeqNum] = {
            ndc: header.ndc,
            drugName: header.drugName,
            drugSeqNum: header.drugSeqNum,
          };
        });

        unitGridDataAll.forEach((unit) => {
          if (!groupedByDrugSeq[unit.drugSeqNum]) {
            groupedByDrugSeq[unit.drugSeqNum] = {
              units: [],
              claims: [],
              headerInfo: headerDataMap[unit.drugSeqNum] || {},
            };
          }
          groupedByDrugSeq[unit.drugSeqNum].units.push(unit);
        });

        allAdjustedClaimsData.forEach((claim) => {
          if (groupedByDrugSeq[claim.drugSeqNum]) {
            groupedByDrugSeq[claim.drugSeqNum].claims.push(claim);
          }
        });

        const unitColumnsToExport = CMSUnitInformation
          .filter((col) => col.field && !col.removeColumn)
          .map((col) => {
            if (col.field === 'dramsUnitTypeCd') {
              return { field: 'unitTypeConversion', headerName: col.headerName };
            }
            if (col.field === 'drugFileUnitType') {
              return { field: 'unitTypeConversion', headerName: col.headerName };
            }
            return { field: col.field, headerName: col.headerName };
          });

        const adjustedClaimsColumnsToExport = AdjustedClaimsData
          .filter((col) => col.field && !col.removeColumn)
          .map((col) => ({ field: col.field, headerName: col.headerName }));

        const selectionCriteria = {
          invoiced: checkboxValuesInvoice.invoice ? 'Yes' : 'No',
          notInvoiced: checkboxValuesInvoice.nonInvoiced ? 'Yes' : 'No',
          billedUnits: checkboxValuesUnit.billed ? 'Yes' : 'No',
          notBilledUnits: checkboxValuesUnit.notBilled ? 'Yes' : 'No',
          forDisputeResolution: checkboxValuesDispute.yes ? 'Yes' : 'No',
          notForDisputeResolution: checkboxValuesDispute.no ? 'Yes' : 'No',
        };

        const options = {
          pageSize: {
            width: 1920,
            height: 1080,
          },
          fileName,
          rebateProgramName: `${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`,
          quarter: startQtrValue,
          claimCategory: claimLong,
          selectedCriteria: selectionCriteria,
        };

        dispatch(dispatchTableLoader(false));

        exportAdjustedClaimsPDF(
          groupedByDrugSeq,
          unitColumnsToExport,
          adjustedClaimsColumnsToExport,
          options,
          logInUser
        );
      } else {
        dispatch(dispatchTableLoader(false));
        setErrorMessages([constantMessageData.STATUS_MSG]);
      }
    } catch (error) {
      dispatch(dispatchTableLoader(false));
      setErrorMessages([constantMessageData.STATUS_MSG]);
    }
  };

  

  const exportCurrentPageHandler = (fileName) => {
    try {
      const infoObj = {
        firstInfo,
        secondInfo,
        thirdInfo,
        fourthInfo,
        fifthInfo,
      };

      const selectedCriteria = {
        invoiced: checkboxValuesInvoice.invoice ? 'Yes' : 'No',
        notInvoiced: checkboxValuesInvoice.nonInvoiced ? 'Yes' : 'No',
        billedUnits: checkboxValuesUnit.billed ? 'Yes' : 'No',
        notBilledUnits: checkboxValuesUnit.notBilled ? 'Yes' : 'No',
        forDisputeResolution: checkboxValuesDispute.yes ? 'Yes' : 'No',
        notForDisputeResolution: checkboxValuesDispute.no ? 'Yes' : 'No',
      };

      const selectionParts = [];
      if (checkboxValuesInvoice.invoice) selectionParts.push('Invoiced: Yes');
      if (checkboxValuesInvoice.nonInvoiced) selectionParts.push('Not Invoiced: Yes');
      if (checkboxValuesUnit.billed) selectionParts.push('Billed Units: Yes');
      if (checkboxValuesUnit.notBilled) selectionParts.push('Not Billed Units: Yes');
      if (checkboxValuesDispute.yes) selectionParts.push('For Dispute Resolution: Yes');
      if (checkboxValuesDispute.no) selectionParts.push('Not For Dispute Resolution: Yes');

      if (unitGridApiRef.current && adjGridApiRef.current) {
        const docDefinition = buildAdjustedClaimsDocDefinition({
          infoObj,
          unitParams: {
            columnApi: unitGridApiRef.current.columnApi,
            api: unitGridApiRef.current.api,
          },
          adjParams: {
            columnApi: adjGridApiRef.current.columnApi,
            api: adjGridApiRef.current.api,
          },
          selectionParts,
          selectedCriteria,
          fileName,
          logInUser,
        });

        const pdf = pdfMake.createPdf(docDefinition);
        pdf.download(`${fileName || 'AdjustedClaims'}.pdf`);
      } else {
        setErrorMessages(['Unable to export PDF - grids not initialized']);
      }
    } catch (error) {
      setErrorMessages([constantMessageData.STATUS_MSG]);
    }
  };

  return (
    <div className="tabs-contaitBillPanel custom-check tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator
        parent1="Detail Reports"
        parent2="Display Adjusted Claims Report"
      />
      <DisplayErrorMessages errorMessages={[...new Set(errorMessages)]} />
      <div className="tab-body">
        {!fullScreenView1 && (
          <>
            <div className="row mb-5">
              <div className="col-12">
                <PaginationBox
                  array={paginationArray}
                  count={count}
                  handleClick={handleClick}
                  handleBlur={handleBlur}
                />
              </div>
            </div>
            <div className="panel custom-fieldset">
              <div className="custom-check">
                <div className="form-wrapper">
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="NDC : "
                        id="NDC"
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="NDC"
                        value={selectByBasis[getSelectByList].NDC}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Drug Name "
                        id="Drug Name"
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        name="Drug Name "
                        disabled
                        value={
                          selectByBasis[getSelectByList]?.drugName ||
                          (drugNameData && drugNameData[0]?.drugName)
                        }
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Rebate_Program"
                        label="Rebate Program"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Rebate_Program' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={`${getRebateProgramName?.rebateProgramCd} - ${getRebateProgramName?.shortDescr}`}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        id="Paid_Quarter"
                        label="Paid Quarter"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Paid_Quarter' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={startQtrValue}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="End Quarter "
                        id="End_Quarter"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'End_Quarter' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={endQtrValue || currentQuarterWithYear}
                      />
                    </div>
                  </div>
                  <div className="mui-custom-form input-md">
                    <div className="col-12">
                      <TextField
                        label="Claim Category Cd "
                        id="Claim_Category_Cd"
                        fullWidth
                        placeholder=""
                        inputProps={{ id: 'Claim_Category_Cd' }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled
                        value={claimLong}
                      />
                    </div>
                  </div>
                  <div className="col-4 frr-two-col-radio">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">
                        Unit Changed Type
                      </legend>
                      <div className="form-wrapper p-2">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <RadioGroup row name="report-quarter" required>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={checkboxValuesUnit.billed}
                                  color="primary"
                                  name="Billed Units"
                                  onChange={(e) => {
                                    dispatch(
                                      dispatchUnitChangedType({
                                        ...checkboxValuesUnit,
                                        billed: !checkboxValuesUnit.billed,
                                      })
                                    );
                                    setCheckboxValuesUnit({
                                      ...checkboxValuesUnit,
                                      billed: !checkboxValuesUnit.billed,
                                    });
                                  }}
                                />
                              }
                              label="Yes"
                              disabled
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={checkboxValuesUnit.notBilled}
                                  color="primary"
                                  name="Not Billed Units"
                                  onChange={(e) => {
                                    dispatch(
                                      dispatchUnitChangedType({
                                        ...checkboxValuesUnit,
                                        notBilled:
                                          !checkboxValuesUnit.notBilled,
                                      })
                                    );
                                    setCheckboxValuesUnit({
                                      ...checkboxValuesUnit,
                                      notBilled: !checkboxValuesUnit.notBilled,
                                    });
                                  }}
                                />
                              }
                              label="No"
                              disabled
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <div className="col-4 frr-two-col-radio">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">
                        For Dispute Resolution
                      </legend>
                      <div className="form-wrapper p-2">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <RadioGroup row name="report-quarter" required>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={checkboxValuesDispute.yes}
                                  color="primary"
                                  name="Yes"
                                  onChange={(e) => {
                                    dispatch(
                                      dispatchDisputeResolution({
                                        ...checkboxValuesDispute,
                                        yes: !checkboxValuesDispute.yes,
                                      })
                                    );
                                    setCheckboxValuesDispute({
                                      ...checkboxValuesDispute,
                                      yes: !checkboxValuesDispute.yes,
                                    });
                                  }}
                                />
                              }
                              label="Yes"
                              disabled
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={checkboxValuesDispute.no}
                                  color="primary"
                                  name="No"
                                  onChange={(e) => {
                                    dispatch(
                                      dispatchDisputeResolution({
                                        ...checkboxValuesDispute,
                                        no: !checkboxValuesDispute.no,
                                      })
                                    );
                                    setCheckboxValuesDispute({
                                      ...checkboxValuesDispute,
                                      no: !checkboxValuesDispute.no,
                                    });
                                  }}
                                />
                              }
                              label="No"
                              disabled
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div className="col-4 frr-two-col-radio">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">
                        Invoice Status
                      </legend>
                      <div className="form-wrapper p-2">
                        <div className="mui-custom-form with-select field-xl no-lbl">
                          <RadioGroup row name="report-quarter" required>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={checkboxValuesInvoice.invoice}
                                  color="primary"
                                  name="Invoiced"
                                  onChange={(e) => {
                                    dispatch(
                                      dispatchInvoiceStatus({
                                        ...checkboxValuesInvoice,
                                        invoice: !checkboxValuesInvoice.invoice,
                                      })
                                    );
                                    setCheckboxValuesInvoice({
                                      ...checkboxValuesInvoice,
                                      invoice: !checkboxValuesInvoice.invoice,
                                    });
                                  }}
                                />
                              }
                              label="Yes"
                              disabled
                            />
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={checkboxValuesInvoice.nonInvoiced}
                                  color="primary"
                                  name="Non Invoiced"
                                  onChange={(e) => {
                                    dispatch(
                                      dispatchInvoiceStatus({
                                        ...checkboxValuesInvoice,
                                        nonInvoiced:
                                          !checkboxValuesInvoice.nonInvoiced,
                                      })
                                    );
                                    setCheckboxValuesInvoice({
                                      ...checkboxValuesInvoice,
                                      nonInvoiced:
                                        !checkboxValuesInvoice.nonInvoiced,
                                    });
                                  }}
                                />
                              }
                              label="No"
                              disabled
                            />
                          </RadioGroup>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="panel-body FRR-custom-table tbl-manufacturer-inner">
          <TableGrid
            data-testid="cms-conversion-information"
            fullScreenView={fullScreenView1}
            handleFullScreenViewClick={handleFullScreenView1}
            rowSelection="single"
            rowMultiSelectWithClick={false}
            columnDefs={CMSUnitInformation}
            rowData={getUnitGridList?.map((item) => {
              return {
                ...item,
                cmsUnitFactor: item.cmsUnitFactor,
                billedUnitFactor: item.billedUnitFactor?.toFixed(4),
                drugFileUnitType: item.dramsUnitTypeCd,
              };
            })}
            gridHeight={fullScreenView1 ? '70vh' : viewPortHeight_200}
            exportFile
            exportAllTpPDF={exportAllToPDF}
            showExportPdfOption={false}
            exportToPDF={exportCurrentPageHandler}
            onGridReady={(params) => {
              unitGridApiRef.current = params;
            }}
            defaultCol={{
              wrapHeaderText: true,
              autoHeaderHeight: true,
            }}
            fileName="AdjustedClaims"
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            isScrollOn
            onCellFocused={onCellFocused}
            navigateHandler={navigateHandler}
            showAdditionalOptions
            countValue={count}
            info={{ firstInfo, secondInfo, thirdInfo, fourthInfo, fifthInfo }}
          />{' '}
        </div>

        <div className="panel-body FRR-custom-table tbl-manufacturer-inner bottom-pinned-bold">
          <TableGrid
            data-testid="adjusted-claims"
            fullScreenView={fullScreenView2}
            handleFullScreenViewClick={handleFullScreenView2}
            rowSelection="single"
            countValue={count}
            rowMultiSelectWithClick={false}
            showExportPdfOption={false}
            columnDefs={AdjustedClaimsData}
            isScrollOn
            rowData={adjustedGridReduxList
              ?.filter(
                (o) =>
                  o.drugSeqNum === selectByBasis[getSelectByList]?.drugSeqNumber
              )
              ?.map((item) => {
                return {
                  ...item,
                  submittedAmt: item.submittedAmt
                    ? item.submittedAmt?.toFixed(2)
                    : '0.00',

                  allowedAmt: item.allowedAmt
                    ? item.allowedAmt?.toFixed(2)
                    : '0.00',

                  reimbursementAmt: item.reimbursementAmt
                    ? item.reimbursementAmt.toFixed(2)
                    : '0.00',
                  reversingClaimId: item.reversingClaimId, // ? 1 : 0,
                  origNumOfUnits: parseFloat(item.origNumOfUnits)?.toFixed(4),
                  numOfUnits: item.numOfUnits?.toFixed(4),
                  billedUnits: item.billedUnits?.toFixed(4),
                  checkbox: true,
                  providerIdTypeCd: getShortDescriptionByCode(item.providerIdTypeCd, providerTypeList)
                };
              })}
            gridHeight={fullScreenView2 ? '70vh' : viewPortHeight_355}
            exportFile
            exportAllTpPDF={exportAllToPDF}
            exportToPDF={exportCurrentPageHandler}
            onGridReady={(params) => {
              adjGridApiRef.current = params;
            }}
            defaultCol={{
              wrapHeaderText: true,
              autoHeaderHeight: true,
            }}
            animateRows
            sideBar={false}
            reportName="Adjusted Claims Report"
            fileName="AdjustedClaims "
            singleClickEdit
            navigateToNextCell={navigateToNextCell}
            // tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onFilterData={onFilterChanged}
            onCellFocused={onCellFocused}
            frameworkComponents={{
              CheckBoxSelectedForRCellRender: (cellInfo) => {
                if (cellInfo.data.isBottomRow) {
                  return null;
                }
                return (
                  <div
                    style={{ marginTop: 10 }}
                    className="ag-cell ag-cell-not-inline-editing ag-cell-normal-height ag-cell-value ag-cell-focus"
                  >
                    <div className="tbl-checkbox frr-checkbox-no-label">
                      <FormControlLabel
                        data-testid="checkBox"
                        label="checkbox"
                        control={<Checkbox color="primary" />}
                        disabled={parseInt(cellInfo.value) !== 1}
                        checked={parseInt(cellInfo.value) === 1}
                        // value={parseInt(cellInfo.value, [0, 1]) === 1}
                      />
                    </div>
                  </div>
                );
              },
              ActionCellRender: (cellInfo) => {
                if (cellInfo?.data?.isBottomRow) {
                  return null;
                }
                return (
                  <div
                    className="tdCell icon-btn-group"
                    data-testid="action-column"
                  >
                    {showComments ? (
                      <Button
                        onClick={() => {
                          setCorrLinkId(cellInfo.data?.corrLinkId);
                          setShowComments(true);
                        }}
                        tabIndex={'0'}
                        onKeyDown={(e) => {
                          // Handle Enter and Space key events
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault(); // Prevents the default space scrolling behavior
                            setCorrLinkId(cellInfo.data?.corrLinkId);
                            setShowComments(true);
                          }
                        }}
                        aria-label="Comment"
                        className={`th-ic comment-ic ${
                          parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1
                            ? 'frr-enabled-comment-btn'
                            : 'frr-disabled-comment-btn'
                        }`}
                        variant="text"
                      >
                        {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                        1 ? (
                          <img alt="" src={CommentVisibleIcon} />
                        ) : (
                          <img alt="" src={CommentIcon} />
                        )}
                      </Button>
                    ) : (
                      <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
                      >
                        <Button
                          disabled={cellInfo.data?.corrLinkId === 'new'}
                          onClick={() => {
                            setCorrLinkId(cellInfo.data?.corrLinkId);
                            setShowComments(true);
                          }}
                          tabIndex={'0'}
                          onKeyDown={(e) => {
                            // Handle Enter and Space key events
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault(); // Prevents the default space scrolling behavior
                              setCorrLinkId(cellInfo.data?.corrLinkId);
                              setShowComments(true);
                            }
                          }}
                          aria-label="Comment"
                          className={`th-ic comment-ic ${
                            parseInt(cellInfo.data?.ccCommentsExist, [0, 1]) ===
                            1
                              ? 'frr-enabled-comment-btn'
                              : 'frr-disabled-comment-btn'
                          }`}
                          variant="text"
                        >
                          {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) ===
                          1 ? (
                            <img alt="" src={CommentVisibleIcon} />
                          ) : (
                            <img alt="" src={CommentIcon} />
                          )}
                        </Button>
                      </OverlayTrigger>
                    )}
                  </div>
                );
              },
            }}
            navigateHandler={navigateHandler}
            showAdditionalOptions
            pinnedBottomRowData={pinnedBottomRowData}
            info={{ firstInfo, secondInfo, thirdInfo, fourthInfo, fifthInfo }}
            getFilterApply={getFilterApply}
          />{' '}
        </div>
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="DRUG_ACTIVITY"
          corrLinkId={corrLinkId}
          rowGridPrimaryKey={null}
        />
      ) : null}
    </div>
  );
};

export default DisplayAdjustedClaims;
